// Контентный попап в рамках компонента welcome popup
// для роли "разработчик"

const template = /* html */`
    <div class="flex-column items-start gap-1">
        <h3>Вот что можно сделать, если вы разработчик</h3>
        <ol class="flex-column items-start gap-1">
            <li>
                Изучить <a href="/api">документацию</a>, 
                чтобы интегрировать наши инструменты по API.
            </li>
            <li>
                Найти API-ключ — он появится в <a href="/profile/#info">личном кабинете</a>, 
                когда вы подтвердите емейл. Ключ пригодится, чтобы обращаться 
                по API к любому из сервисов «Дадаты». 
                <p class="mt-1 mb-0">
                    Иногда API не нужно: инструмент «Подсказки» подключают также с помощью 
                    <a href="/suggestions/usage/">готовых плагинов и модулей</a>. 
                    А в «Стандартизации» чистят excel- и CSV-файлы с данными, 
                    которые уже лежат в базе или достались от подрядчиков. 
                </p>
            </li>
            <li>
                Сразу протестировать нужные сервисы. Для этого мы подключили вам 
                подписку по бесплатному тарифу. 
                <a href="/blog/instructions/integration-guide/#pricing">
                Часть сервисов не входит в подписку</a>, но их тоже 
                тестируют бесплатно — в рамках запросов, которые мы дарим новичкам.
            </li>
            <li v-if="showContacts">
                Подписаться на <a href="https://t.me/+JY6I09ma0f1lZmVi">телеграм-канал 
                «Дадаты» для срочных новостей</a>.
            </li>
        </ol>
        <span v-if="showContacts">
           Если что-то не получается, смело 
           <a :href="'/support/' + userecho">пишите в поддержку</a> — разберемся.
        </span>
    </div>
`;

export default {
    template,
    inject: ["userecho"],
    props: { showContacts: Boolean },
};
